import React from 'react';

const FullPageLoader = () => {
  return (
    <div className="preload loading">
      <ul className="loading-dots">
        <li />
        <li />
        <li />
      </ul>
    </div>
  );
};

export default FullPageLoader;
